import { createAsyncThunk } from '@reduxjs/toolkit';
import { getArticleCategories } from 'conversations-visitor-experience-components/knowledge-base/clients/kb-api.v3';
import Raven from 'raven-js';
export const fetchArticleCategories = createAsyncThunk('articles/fetchArticleCategories', ({
  knowledgeBaseId,
  knowledgeBaseUrl
}) => getArticleCategories({
  knowledgeBaseId,
  knowledgeBaseUrl
}).then(response => response).catch(error => {
  Raven.captureException(error);
  throw error;
}));